import { render, staticRenderFns } from "./AuthorizationSummary.vue?vue&type=template&id=286a632b&scoped=true&"
import script from "./AuthorizationSummary.vue?vue&type=script&lang=js&"
export * from "./AuthorizationSummary.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationSummary.vue?vue&type=style&index=0&id=286a632b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286a632b",
  null
  
)

export default component.exports